"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Combobox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var TimeSelect_1 = require("./TimeSelect");
var util_1 = require("./util");
function Combobox(_a) {
    var _value = _a.value, onChange = _a.onChange, _b = _a.format, format = _b === void 0 ? "HH:mm:ss" : _b, props = tslib_1.__rest(_a, ["value", "onChange", "format"]);
    var value = util_1.getValidTimeValue(_value, props, format);
    var _c = util_1.genShowHourMinuteSecond(format), showHour = _c.showHour, showMinute = _c.showMinute, showSecond = _c.showSecond;
    var _d = _value
        ? util_1.getHourMinuteSecond(value)
        : {}, _e = _d.hour, hour = _e === void 0 ? null : _e, _f = _d.minute, minute = _f === void 0 ? null : _f, _g = _d.second, second = _g === void 0 ? null : _g;
    var handleItemChange = function (type) { return function (selectValue, context) {
        var newValue = value.clone();
        switch (type) {
            case "hour":
                newValue.hour(selectValue);
                break;
            case "minute":
                newValue.minute(selectValue);
                break;
            case "second":
                newValue.second(selectValue);
                break;
        }
        onChange(util_1.getValidTimeValue(newValue, props, format), context);
    }; };
    var _h = props.hourStep, hourStep = _h === void 0 ? 1 : _h, _j = props.minuteStep, minuteStep = _j === void 0 ? 1 : _j, _k = props.secondStep, secondStep = _k === void 0 ? 1 : _k;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showHour && (react_1.default.createElement(TimeSelect_1.TimeSelect, { value: hour, to: 23, step: hourStep, disabledValues: util_1.getDisabledHours(props), onChange: handleItemChange("hour") })),
        showMinute && (react_1.default.createElement(TimeSelect_1.TimeSelect, { value: minute, to: 59, step: minuteStep, disabledValues: util_1.getDisabledMinutes(hour, props), onChange: handleItemChange("minute") })),
        showSecond && (react_1.default.createElement(TimeSelect_1.TimeSelect, { value: second, to: 59, step: secondStep, disabledValues: util_1.getDisabledSeconds(hour, minute, props), onChange: handleItemChange("second") }))));
}
exports.Combobox = Combobox;
Combobox.displayName = "TimePickerCombobox";
//# sourceMappingURL=TimeCombobox.js.map